export enum OrganizationMemberType {
  MEMBER = 'member',
  MANAGER = 'manager',
  INVITED_MEMBER = 'invited_member',
}
